import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Clock, Instagram, Facebook, Send } from 'lucide-react';
export function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="bg-white min-h-screen" data-id="element-469">
      {/* Hero Section */}
      <section className="relative h-[50vh] md:h-[60vh] w-full overflow-hidden" data-id="element-470">
        <img src="https://cdn.magicpatterns.com/uploads/i1yaQ7rhDn8zXPcCiik1U9/Lavender_Picnic(1).jpg" alt="Contact Versatile LLC" className="w-full h-full object-cover" data-id="element-471" />
        <div className="absolute inset-0 bg-brand-black/60" data-id="element-472" />
        <div className="absolute inset-0 flex items-center justify-center text-center px-4 md:px-6" data-id="element-473">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} data-id="element-474">
            <span className="text-brand-gold font-bold tracking-[0.3em] uppercase text-[10px] md:text-xs mb-4 block" data-id="element-475">
              Get In Touch
            </span>
            <h1 className="text-white text-4xl sm:text-5xl md:text-7xl font-serif" data-id="element-476">
              Let's Plan Your Event
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 md:py-16 max-w-7xl mx-auto px-4 md:px-6" data-id="element-477">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-478">
          {/* Left Column: Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-479">
            <h2 className="text-3xl md:text-4xl font-serif mb-6 text-brand-black" data-id="element-480">
              We'd Love to Hear From You
            </h2>
            <p className="text-gray-600 leading-relaxed mb-12" data-id="element-481">
              Whether you're planning a grand wedding, a corporate luncheon, or
              looking for weekly meal prep, our team is ready to bring your
              culinary vision to life. Reach out to us using the form, or
              contact us directly.
            </p>

            <div className="space-y-8" data-id="element-482">
              <div className="flex items-start gap-4" data-id="element-483">
                <div className="w-12 h-12 bg-brand-gold/10 text-brand-gold rounded-full flex items-center justify-center shrink-0" data-id="element-484">
                  <Phone size={20} data-id="element-485" />
                </div>
                <div data-id="element-486">
                  <h3 className="font-bold text-brand-black text-lg" data-id="element-487">
                    Call Us
                  </h3>
                  <p className="text-gray-500 mt-1" data-id="element-488">(202) 555-0123</p>
                  <p className="text-xs text-gray-400 mt-1 uppercase tracking-widest" data-id="element-489">
                    Mon-Fri, 9am - 6pm
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-490">
                <div className="w-12 h-12 bg-brand-gold/10 text-brand-gold rounded-full flex items-center justify-center shrink-0" data-id="element-491">
                  <Mail size={20} data-id="element-492" />
                </div>
                <div data-id="element-493">
                  <h3 className="font-bold text-brand-black text-lg" data-id="element-494">
                    Email Us
                  </h3>
                  <p className="text-gray-500 mt-1" data-id="element-495">
                    hello@versatilityeats.com
                  </p>
                  <p className="text-xs text-gray-400 mt-1 uppercase tracking-widest" data-id="element-496">
                    We reply within 24 hours
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-497">
                <div className="w-12 h-12 bg-brand-gold/10 text-brand-gold rounded-full flex items-center justify-center shrink-0" data-id="element-498">
                  <MapPin size={20} data-id="element-499" />
                </div>
                <div data-id="element-500">
                  <h3 className="font-bold text-brand-black text-lg" data-id="element-501">
                    Location
                  </h3>
                  <p className="text-gray-500 mt-1" data-id="element-502">Gaithersburg, MD</p>
                  <p className="text-xs text-gray-400 mt-1 uppercase tracking-widest" data-id="element-503">
                    Serving the entire DMV Area
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12 pt-12 border-t border-gray-100" data-id="element-504">
              <h3 className="font-bold text-brand-black mb-4 uppercase tracking-widest text-sm" data-id="element-505">
                Follow Our Journey
              </h3>
              <div className="flex gap-4" data-id="element-506">
                <a href="#" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-600 hover:bg-brand-gold hover:text-white transition-all" data-id="element-507">
                  <Instagram size={18} data-id="element-508" />
                </a>
                <a href="#" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-600 hover:bg-brand-gold hover:text-white transition-all" data-id="element-509">
                  <Facebook size={18} data-id="element-510" />
                </a>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4
        }} className="bg-gray-50 p-8 md:p-10 rounded-sm border border-gray-100" data-id="element-511">
            <h3 className="text-2xl font-serif mb-8 text-brand-black" data-id="element-512">
              Send a Message
            </h3>
            <form className="space-y-6" onSubmit={e => {
            e.preventDefault();
            alert('Message sent successfully!');
          }} data-id="element-513">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-514">
                <div data-id="element-515">
                  <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-516">
                    First Name
                  </label>
                  <input type="text" required className="w-full px-4 py-3 border border-gray-200 rounded-sm focus:border-brand-gold outline-none bg-white" data-id="element-517" />
                </div>
                <div data-id="element-518">
                  <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-519">
                    Last Name
                  </label>
                  <input type="text" required className="w-full px-4 py-3 border border-gray-200 rounded-sm focus:border-brand-gold outline-none bg-white" data-id="element-520" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-521">
                <div data-id="element-522">
                  <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-523">
                    Email Address
                  </label>
                  <input type="email" required className="w-full px-4 py-3 border border-gray-200 rounded-sm focus:border-brand-gold outline-none bg-white" data-id="element-524" />
                </div>
                <div data-id="element-525">
                  <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-526">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full px-4 py-3 border border-gray-200 rounded-sm focus:border-brand-gold outline-none bg-white" data-id="element-527" />
                </div>
              </div>

              <div data-id="element-528">
                <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-529">
                  Inquiry Type
                </label>
                <select className="w-full px-4 py-3 border border-gray-200 rounded-sm focus:border-brand-gold outline-none bg-white text-gray-700" data-id="element-530">
                  <option data-id="element-531">General Inquiry</option>
                  <option data-id="element-532">Wedding Catering</option>
                  <option data-id="element-533">Corporate Event</option>
                  <option data-id="element-534">Meal Prep Subscription</option>
                  <option data-id="element-535">Private Party</option>
                </select>
              </div>

              <div data-id="element-536">
                <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-537">
                  Message
                </label>
                <textarea required rows={5} className="w-full px-4 py-3 border border-gray-200 rounded-sm focus:border-brand-gold outline-none bg-white resize-none" placeholder="Tell us about your event or ask a question..." data-id="element-538"></textarea>
              </div>

              <button type="submit" className="w-full bg-brand-black text-white py-4 rounded-sm font-bold uppercase tracking-widest hover:bg-brand-gold transition-all flex items-center justify-center gap-2" data-id="element-539">
                Send Message <Send size={16} data-id="element-540" />
              </button>
            </form>
          </motion.div>
        </div>
      </section>
    </div>;
}